<template>
    <div v-if="loading_titulo === true">
      <loading />
    </div>
    <div v-else>
      <div class="col s12 m12 no-padding doc-type-section">
        <div class="input-field col s12 m6">
          <input v-model="titulo.pf_tit_ele" id="tit_numero" type="text" class="validate">
          <label for="tit_numero">Número</label>
        </div>
        <div class="input-field col s12 m3">
          <input v-model="titulo.pf_tit_ele_zon" id="tit_zona" type="text" class="validate">
          <label for="tit_zona">Zona</label>
        </div>
        <div class="input-field col s12 m3">
          <input v-model="titulo.pf_tit_ele_sec" id="tit_secao" type="text" class="validate">
          <label for="tit_secao">Seção</label>
        </div>
        <div class="input-field col s12 m6">
          <input v-model="titulo.pf_tit_ele_emissao"  v-mask="['##/##/####']" id="tit_dt_emissao" type="text" class="validate">
          <label for="tit_dt_emissao">Data de Emissão</label>
        </div>
        <div class="input-field col s12 m6">
          <input @input="searchLocalidade()" v-model="localidade" type="text" id="tit_localidade" class="autocomplete" autocomplete="none">
          <label for="tit_localidade">Localidade</label>
        </div>
      </div>
      <div class="input-field col s12 m12">
        <button @click="prepareSubmitTitulo" v-bind:disabled="verificaForm === false" class="btn right" type="button">SALVAR</button>
      </div>
    </div>
</template>

<script>
import axios from 'axios'
import Loading from '@/components/Loading.vue'
import {converteData, formataData} from '@/assets/js/form-utils.js'
import {CONFIG} from '@/config/config.js'
import SocialService from '@/services/social-service.js'
import { verificaData } from '@/assets/js/form-utils'
import sha1 from 'js-sha1'

let socialService = new SocialService(CONFIG.URL_SOCIAL_API_V2)

export default {
  name: 'TituloEleitor',
  components: {
    'loading': Loading,
  },
  props: {
      doc: Object,
      pf_id: String
  },
  data (){
    return {
      loading_titulo: false,
      meta: this.$store.state.meta.data,
      titulo: {
        pf_tit_ele: this.doc.titulo_eleitor,
        pf_tit_ele_sec: this.doc.secao,
        pf_tit_ele_zon: this.doc.zona,
        pf_tit_ele_emissao: (verificaData(this.doc.emissao, 'YYYY-MM-DD') === true ? converteData(this.doc.emissao) : null),
        cidade_id: this.doc.localidade,
      },
      error_fields: {},
      loaded: null,
      localidade: null,
      obj_localidade: null,
      obj_cidades: {},
    }
  },
  computed: {
    verificaForm: function() {
        let status = (
            ['pf_tit_ele', 'pf_tit_ele_zon', 'pf_tit_ele_sec', 'pf_tit_ele_emissao', 'cidade_id'].every((k) => this.titulo[k] && this.titulo[k] != '')
            && 
            (verificaData(this.titulo.pf_tit_ele_emissao) === true)
        )
        this.$emit('statusChange', {
          doc: 4,
          status: status
        })
        return status
    }
  },
  methods: {
    async submitInsertTitulo(titulo){
      axios.post(`${CONFIG.URL_SOCIAL_API_V2}/v1/pessoa-fisica/titulo-eleitor/`, {
        ...titulo,
        ...{
          'pf_id': this.pf_id,
          'device': await socialService.getDeviceInfo()
        }
      })
      .then((response) => {
        this.loading_titulo = false
        setTimeout(() => {
          this.initFields()
          this.$emit('docSaved', 3)
        }, 100)
      })
      .catch((error) => {
        M.toast({html: 'Não foi possível realizar esta operação...verifique a sua conexão com a internet e tente novamente!'})
        this.loading_titulo = false
        setTimeout(() => {
          this.initFields()
        }, 100)
      })
    },
    prepareSubmitTitulo(){
      this.loading_titulo = true
      let a = this.titulo //Atual

      let titulo = {
        pf_id: this.pf_id,
        pf_tit_ele: this.titulo.pf_tit_ele,
        pf_tit_ele_sec: this.titulo.pf_tit_ele_sec,
        pf_tit_ele_zon: this.titulo.pf_tit_ele_zon,
        pf_tit_ele_emissao: (verificaData(this.titulo.pf_tit_ele_emissao, 'YYYY-MM-DD') === true ? formataData(this.titulo.pf_tit_ele_emissao) : null),
        cidade_id: this.titulo.cidade_id || null
      }

      if(this.loaded !== sha1(JSON.stringify(titulo))){
        return this.submitInsertTitulo(titulo)
      } else {
        this.loading_titulo = false
        this.$emit('docSaved', 3)
      }
    },
    searchLocalidade(){
      if(!(this.localidade in this.obj_cidades) || this.obj_cidades[this.localidade].cidade_id !== this.titulo.cidade_id){
        this.titulo.cidade_id = null
      }

      if(!this.localidade || this.localidade.length < 3){
        return
      }

      axios.get(`${CONFIG.URL_UFCIDADE_API}/v1/cidade/nome/${encodeURIComponent(this.localidade)}/`)
      .then((response) => {
        let cidades = {}
        response.data.data.UFCidadeAPI.forEach((opt) => {
          cidades[opt['cidade_nome']+', '+opt['uf_sigla']] = null
          this.obj_cidades[opt['cidade_nome']+', '+opt['uf_sigla']] = opt
        })
        if(this.obj_localidade){
          this.obj_localidade.updateData(cidades)
          this.obj_localidade.open()
        }
      })
      .catch((error) => {
        //NO-ACTION
      })
    },
    selectLocalidade(cidade){
      let cidadeObj = this.obj_cidades[cidade]
      this.localidade = cidadeObj.cidade_nome+', '+cidadeObj.uf_sigla
      if(typeof cidadeObj.cidade_id === 'number'){
        this.titulo.cidade_id = cidadeObj.cidade_id
      }
    },
    getNomeCidade(cidade_id){
      axios.get(`${CONFIG.URL_UFCIDADE_API}/v1/cidade/id/${cidade_id}/`)
      .then((response) => {
        let cidade = response.data.data.UFCidadeAPI
        this.localidade = cidade.cidade_nome+', '+cidade.uf_sigla
        this.obj_cidades[this.localidade] = cidade
        setTimeout(() => {M.updateTextFields()}, 100)
      })
      .catch((error) => {
      })
    },
    initFields () {
      M.updateTextFields()
      M.FormSelect.init(document.querySelectorAll('select'))
      this.obj_localidade = M.Autocomplete.init(document.querySelectorAll('#tit_localidade'), {
        onAutocomplete: selected => this.selectLocalidade(selected)
      })[0]
    },
    verificaStatusDocumento(){
      return true //Não obrigatório
    }
  },
  mounted(){
    this.loaded = sha1(JSON.stringify({
      pf_id: this.pf_id,
      pf_tit_ele: this.titulo.pf_tit_ele,
      pf_tit_ele_sec: this.titulo.pf_tit_ele_sec,
      pf_tit_ele_zon: this.titulo.pf_tit_ele_zon,
      pf_tit_ele_emissao: (verificaData(this.titulo.pf_tit_ele_emissao, 'YYYY-MM-DD') === true ? formataData(this.titulo.pf_tit_ele_emissao) : null),
      cidade_id: this.titulo.cidade_id || null
    }))

    if(this.titulo.cidade_id){
      this.getNomeCidade(this.titulo.cidade_id)
    }

    this.initFields()
  }
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/steps/documentos/TituloEleitor.vue